import 'css-chunk:src/utils/ErrorBoundary/ErrorBoundary.scss';export default {
  "ErrorBoundary": "_ErrorBoundary_khnz5_1"
};